import "antd/es/checkbox/style";
import _Checkbox from "antd/es/checkbox";
import React, { useCallback } from 'react';
import MultiCascader from '../container';
import { hasChildChecked, hasParentChecked } from '../libs/utils';
export default /*#__PURE__*/React.memo(function (props) {
  var node = props.node;

  var _MultiCascader$useCon = MultiCascader.useContainer(),
      containerValue = _MultiCascader$useCon.value,
      handleSelectChange = _MultiCascader$useCon.handleSelectChange;

  var handleChange = useCallback(function (event) {
    var checked = event.target.checked;
    handleSelectChange(node, checked);
  }, [node]); // FIXME: 由于异步数据同步问题尚未解决，暂时移除 useMemo

  var checked = hasParentChecked(node, containerValue);
  var indeterminate = !checked && hasChildChecked(node, containerValue);
  return /*#__PURE__*/React.createElement(_Checkbox, {
    onChange: handleChange,
    checked: checked,
    indeterminate: indeterminate,
    disabled: node.disabled
  });
});